import { formatDateGanttChartDefault, formatDateDefault } from './DateFormatters';
import { isDateBefore, isDateAfter } from './DateService';
import { sortByDate } from './sorting';

export const mapToGanttData = (portfolioData) => {
    let taskData = new Array();
    let linkData = new Array();
    let ganttData = {};
    let rowId = 1;

    if (Array.isArray(portfolioData?.initiatives) && portfolioData?.initiatives?.length > 0) {
        for (const initiative of portfolioData?.initiatives) {
            const initiativeGanttEntry = {
                id: rowId,
                text: initiative?.name,
                type: 'initiative',
                order: rowId.toString(),
                open: false,
                parent: 0,
                objectId: initiative?.id
            };
            const parentId = rowId; // store for any features
            let startDate = null; // to update the start date of the feature - earliest start date of all the features
            let endDate = null; // to update the end date of the feature - latest end date of all the features
            rowId++;
            const features = portfolioData?.features?.filter((feature) => initiative?.id === feature?.initiativeId);
            const featureGanttEntries = new Array();
            for (const feature of features) {
                const featureGanttEntry = {
                    id: rowId,
                    text: feature?.name,
                    type: 'feature',
                    order: rowId.toString(),
                    open: false,
                    start_date: formatDateGanttChartDefault(feature?.startDate),
                    end_date: formatDateGanttChartDefault(feature?.endDate),
                    parent: parentId,
                    objectId: feature?.id,
                    color: '#2196F3'
                };
                featureGanttEntries.push(featureGanttEntry);
                const featureParentId = rowId; // store for any issues
                rowId++;
                const issues = portfolioData?.issues?.filter((issue) => feature?.id === issue?.featureId);
                for (const issue of issues) {
                    const issueGanttEntry = {
                        id: rowId,
                        text: issue?.name,
                        type: 'issue',
                        order: rowId.toString(),
                        open: false,
                        start_date: formatDateGanttChartDefault(issue?.startDate),
                        end_date: formatDateGanttChartDefault(issue?.endDate),
                        parent: featureParentId,
                        objectId: issue?.id,
                        color: '#4dd0e1'
                    };
                    taskData.push(issueGanttEntry);
                    rowId++;
                }
                startDate = isDateBefore(formatDateDefault(startDate), formatDateDefault(feature?.startDate)) ? startDate : feature?.startDate;
                endDate = isDateAfter(formatDateDefault(endDate), formatDateDefault(feature?.endDate)) ? endDate : feature?.endDate;
            }
            // okay - we have calculated the initiative start date from the earliest and latest start and end dates of the features
            // we do have dates in the initiatives so use them - use feature dates as backup if not set on the initiative
            if (initiative?.startDate && initiative?.endDate) {
                startDate = initiative?.startDate;
                endDate = initiative?.endDate;
            }
            taskData.push({
                ...initiativeGanttEntry,
                start_date: formatDateGanttChartDefault(startDate || new Date()),
                end_date: formatDateGanttChartDefault(endDate || new Date())
            });
            let id = 1; // TODO - passed to method - have to get latest value back
            if (featureGanttEntries) {
                const links = featureGanttEntries?.length > 1 ? mapDependenciesToGanttLinkData(portfolioData?.features, featureGanttEntries, id) : null;
                const sortedFeatureGanttEntries = sortByDate(featureGanttEntries, 'startDate');
                for (const featureGanttEntry of sortedFeatureGanttEntries?.reverse()) {
                    taskData.push(featureGanttEntry);
                }
                if (links) linkData = linkData.concat(links);
            }
        }
        ganttData = { data: taskData, links: linkData };
    }
    return ganttData;
};

// portfolioData?.features, featureGanttEntries
// {
//     'id': '4',
//     'source': '2',
//     'target': '5',
//     'type': '2'
//   }
const mapDependenciesToGanttLinkData = (allFeatures, featureGanttEntries, id) => {
    let linkData = new Array();
    for (const featureEntry of featureGanttEntries) {
        // get the original feature and see if it has dependencies
        const feature = allFeatures?.find((feature) => feature?.id === featureEntry?.objectId);
        if (feature) {
            // have the original feature so see if it has inward dependencies
            feature?.dependencies?.forEach((link) => {
                let linkedId = 0;
                if (link?.outward !== undefined) {
                    linkedId = link?.outward?.id;
                }
                // has an outward link so check if that other dependency is in the gantt items list to create the link
                const found = featureGanttEntries?.find((element) => element?.objectId === linkedId);
                if (found) {
                    linkData.push({
                        id,
                        source: featureEntry?.id,
                        target: found?.id,
                        type: 0
                    });
                    id++;
                }
            });
        }
    }
    return linkData;
};


// WEBPACK FOOTER //
// ./services/portfolioService.js